export default {
    "affiliation": "good",
    "inventory": {"gold": 0},
    "party": {
        "units": {
            "princess": {
                "key": "princess",
                "jobKey": "sword",
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 50,
                "moverange": 2,
                "skills": [
                    "inflict-damage",
                    "rally",
                    "recruit",
                ],

                "name": "PRINCESS",
                "faceKey": "human",
                "bodyKey": "good",

                "dialogue": {
                    "death": "Damn."
                },

                "portraits": {
                    // "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-neutral.png"),
                    "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-neutral2.png"),
                    "angry": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-angry.png"),
                    "happy": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-happy.png"),
                },
            },
            "hero": {
                "key": "hero",
                "jobKey": "hammer",
                "aliases": ["Himmel", "paladin", "Masked Man"],
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 50,
                "skills": [
                    "inflict-damage",
                    "smite",
                    "recruit",
                ],

                "name": "HERO",
                "faceKey": "human",
                "bodyKey": "good",

                "dialogue": {
                    "death": "Damn."
                },
            },
            "friend": {
                "key": "friend",
                "jobKey": "bow",
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 40,
                "skills": [
                    "inflict-damage",
                    "pull",
                    "recruit",
                ],

                "name": "FRIEND",
                "faceKey": "human",
                "bodyKey": "good",

                "dialogue": {
                    "death": "Damn."
                },
            },
            "aide": {
                "key": "aide",
                "jobKey": "dagger",
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 40,
                "skills": [
                    "inflict-damage",
                    "swap",
                    "recruit",
                ],

                "name": "AIDE",
                "faceKey": "human",
                "bodyKey": "good",

                "dialogue": {
                    "death": "Damn."
                },
            },
        }
    },
}
